





























import { Component, Vue, Prop } from "vue-property-decorator";
import PicPreview from "@/components/pic-preview.vue";
import { getZhuanjia } from "@/request/idr";
import TimeTab from "./time-tab.vue";
import Jiqi from "./jiqi.vue";
import Zhuanjia from "./zhuanjia.vue";
@Component({
  components: {
    PicPreview,
    TimeTab,
    Jiqi,
    Zhuanjia
  }
})
export default class IdrSheKeyan extends Vue {
  @Prop()
  private message: any;
  private current: any = {
    舌象照片: {},
    舌色参数: [],
    苔色参数: [],
    舌象信息输出: {},
    舌型定性判读: []
  };
  private ifShowPicPreview: boolean = false;
  private picUrl: any = "";
  private tongueIndex: any = 0;
  private cPart: any = "机器";
  private changeCurrentItem(item, index) {
    this.$set(this, "current", item);
    this.tongueIndex = index;
    this.cPart = "机器";
  }
  /**
   * @description 打开预览图
   */
  private showPreview(url) {
    this.picUrl = url;
    this.ifShowPicPreview = true;
  }
  /**
   * @description 改变当前展示的part
   */
  private partChange(part) {
    if (part === "专家") {
      const params = {
        params: {
          tongue_id: this.current.tongue_id
        }
      };
      getZhuanjia(this, params).then((data: any) => {
        this.$set(this, "current", data);
        this.cPart = part;
      });
    } else {
      this.current = this.message[this.tongueIndex];
      this.cPart = part;
    }
  }
  /**
   * @description 刷新所有数据
   */
  private refresh() {
    this.$emit("refresh");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.message && this.message.length > 0) {
      this.current = this.message[0];
    }
  }
}
